import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../../components/loader/Loader";
import SettingsPagesContainer from "../../../../components/settingsPagesContainer/SettingsPagesContainer";
import { fetchRegions } from "../../../../features/regions/regionsSlice";
import styles from "./allRegions.module.css";
import OneRegion from "./oneRegion/OneRegion";

const AllRegions = () => {
  const dispatch = useDispatch();
  const {
    list: regions,
    fetchStatus,
    deleteStatus,
    updateStatus,
  } = useSelector((state) => state.regions);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchRegions());
    }
  }, [dispatch, fetchStatus]);

  const displayRegions = regions.map((item) => (
    <OneRegion
      regionId={item._id}
      key={item._id}
      name={item.name}
      peakTimeStart={item.peakTimeStart}
      peakTimeEnd={item.peakTimeEnd}
      image={item.image}
    />
  ));

  return (
    <SettingsPagesContainer title="جميع المناطق">
      {fetchStatus === "loading" ||
      deleteStatus === "loading" ||
      updateStatus === "loading" ? (
        <div className={styles.loaderContainer}>
          <Loader />
        </div>
      ) : (
        displayRegions
      )}
    </SettingsPagesContainer>
  );
};

export default AllRegions;
